const EventEmitter = require('events');

export class PowerArray extends Array {
    #eventPool = {};
    #emitter = new EventEmitter;

    constructor(...args) {
        super(...args);
    }

    emit = (event, payload) => {
        setTimeout(() => {
            if (this.#eventPool[event])
                delete this.#eventPool[event]
        }, 15000)

        this.#eventPool[event] = payload;
        this.#emitter.emit(event, payload)
    }

    on = (event, cb) => {
        return new Promise((resolve, reject) => {
            // Check If Event Pool dosen't Contain The Event
            if (this.#eventPool[event])
                resolve(this.#eventPool[event])
            // Else Wait For Event
            this.#emitter.on(event, cb)
        })
    }

    off = (event, cb) => {
        this.#emitter.off(event, cb)
    }

    once = (event) => {
        return new Promise((resolve, reject) => {
            // Check If Event Pool dosen't Contain The Event
            if (this.#eventPool[event])
                resolve(this.#eventPool[event])

            // Add A Timeout
            const timeout = setTimeout(() => {
                this.#emitter.off(event, resolver)
                reject(new Error('Timeout Exceeded'))
            }, 15000)

            const resolver = (payload) => {
                try {
                    clearTimeout(timeout)
                } catch (e) {
                    // Ignore
                } finally {
                    resolve(payload)
                }
            }

            // Else Wait For Event
            this.#emitter.once(event, resolver)
        })
    }
}